import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleReviewPage from "../pages/article/review/page";
import ArticleTemplatesPage from "../pages/article/templates/page";
import ArticleVsExcelPage from "../pages/article/vs-excel/page";
import ArticleBusinessPage from "../pages/article/business/page";
import ArticleVsGoogleSheetsPage from "../pages/article/vs-google-sheets/page";
import ArticleSecurityPage from "../pages/article/security/page";
import ArticleTipsPage from "../pages/article/tips/page";
import ArticleAlternativesPage from "../pages/article/alternatives/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/what-is-vigorbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-review-2026",
    element: <ArticleReviewPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-templates-guide",
    element: <ArticleTemplatesPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-vs-excel",
    element: <ArticleVsExcelPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-for-business",
    element: <ArticleBusinessPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-vs-google-sheets",
    element: <ArticleVsGoogleSheetsPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-security-guide",
    element: <ArticleSecurityPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-tips-tricks",
    element: <ArticleTipsPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-alternatives",
    element: <ArticleAlternativesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;